document.addEventListener("DOMContentLoaded", function (event) {
  // 初始化执行一次
  updateLayout();

  // 监听窗口大小变化，立即执行
  window.addEventListener("resize", function () {
    updateLayout();
  });
});

function updateLayout() {
  let width = window.innerWidth;
  let search = document.querySelectorAll(".search-modal__form");
  let logo = document.querySelector(".header__heading-logo-wrapper").offsetWidth;

  if (width > 749) {
    let menu_nav = document.querySelector(".menu_nav").offsetWidth;
    let filter = document.querySelector(".filter_left");

    // 计算 menu_nav 的宽度
    menu_nav = width - menu_nav - 100;
    let menu_nav1 = menu_nav;

    // 如果存在 filter，减去其宽度
    if (filter) {
      menu_nav1 = menu_nav - filter.offsetWidth;
    }

    // 更新搜索框的最大宽度
    search.forEach((item) => {
      item.style.maxWidth = menu_nav1 - logo - 400 + "px";
    });

    // 更新页面宽度
    let page_widths = document.querySelectorAll(".page-width");
    page_widths.forEach(function (e) {
      if (e.classList.contains("header") || e.classList.contains("search-modal__content")) {
        e.style.width = menu_nav1 + "px";
        e.style.maxWidth = menu_nav1 + "px";
      } else {
        e.style.width = menu_nav + "px";
        e.style.maxWidth = menu_nav + "px";
      }
    });
  }
}